export function normalizeString(str) {
  if (!str) return "";

  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[\[\]{}()*+?.,\\^$|#\s-]/g, "")
    .toLowerCase();
}
